module.exports = __webpack_public_path__ + "img/news_post_2.fe0e3fdd.png";